import { createConfirmation } from "react-confirm";
import AddImageListDialog from "./AddImageListPage";

export const showAddImageListDialog = createConfirmation(AddImageListDialog);
